import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";

const PlatformPage = lazy(() => import("@/pages/PlatformPage"));
const InsightsPage = lazy(() => import("@/pages/InsightsPage"));
const SolutionsPage = lazy(() => import("@/pages/SolutionsPage"));
const PlansPage = lazy(() => import("@/pages/PlansPage"));
const CompanyPage = lazy(() => import("@/pages/CompanyPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const DemoPage = lazy(() => import("@/pages/DemoPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const ArticlePage = lazy(() => import("@/pages/ArticlePage"));
const AdminBlogPage = lazy(() => import("@/pages/AdminBlogPage"));
const AdminLeadsPage = lazy(() => import("@/pages/AdminLeadsPage"));
const AskAnford = lazy(() => import("@/components/assistant/AskAnford"));

const Loading = () => <div className="min-h-[60vh]" aria-hidden="true" />;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/platform" element={<PlatformPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/plans" element={<PlansPage />} />
              <Route path="/company" element={<CompanyPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<ArticlePage />} />
              <Route path="/resources" element={<BlogPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="/privacy" element={<LegalPage title="Privacy Policy" summary="How ANFORD collects, uses and protects personal information on this website." />} />
              <Route path="/terms" element={<LegalPage title="Terms of Service" summary="The terms governing use of the ANFORD website and services." />} />
              <Route path="/cookies" element={<LegalPage title="Cookie Policy" summary="How ANFORD uses cookies and similar technologies on this website." />} />
              <Route path="/admin/leads" element={<AdminLeadsPage />} />
              <Route path="/admin/blog" element={<AdminBlogPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
        <Suspense fallback={null}>
          <AskAnford />
        </Suspense>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
